const apiUrl = process.env.REACT_APP_API_LINGVO_SEMANTIC;

export const authLogin = async (userName, password) => {
  const response = await fetch(`${apiUrl}/auth/token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ username: userName, password: password }),
  });

  if (!response.ok) {
    throw new Error(`Ошибка при авторизации: ${response.status}`);
  }
  return response.json(); // ожидаем, что сервер вернёт созданный объект
};
